export const ADD_ITEMS_COUNT = 20;
export const MAX_ITEMS_COUNT = 100;
export const MAX_REQUEST_COUNT = 3;
